import { Loader2 } from 'lucide-react';

const SIZES = { sm: 'h-3.5 w-3.5', md: 'h-5 w-5', lg: 'h-7 w-7' };

export function Spinner({ size = 'md', className = '', label }) {
  return (
    <Loader2
      role="status"
      aria-label={label ?? 'Loading'}
      className={`animate-spin shrink-0 ${SIZES[size] ?? SIZES.md} ${className}`}
    />
  );
}

/** FE-9: the loading state of an asynchronous view, as a named component. */
export function Loading({ label = 'Loading…', className = '' }) {
  return (
    <div className={`flex flex-col items-center justify-center gap-3 py-16 ${className}`}>
      <Spinner size="lg" className="text-faint" />
      <p className="text-sm text-muted">{label}</p>
    </div>
  );
}

/** A shimmer placeholder, for when the shape of the content is already known. */
export function Skeleton({ className = 'h-4 w-full' }) {
  return <div className={`skeleton ${className}`} aria-hidden="true" />;
}

export default Spinner;
